import { show } from 'redux-modal'
import { GENERIC_MESSAGE_MODAL } from 'constant'

export const showGenericMessageModal = props => dispatch => {
  dispatch(show(GENERIC_MESSAGE_MODAL, props))
}
